import React from 'react'
import './footer.css'
import {FaFacebookF} from 'react-icons/fa'
import {FiInstagram} from 'react-icons/fi'
import {IoLogoTwitter} from 'react-icons/io'

const Footer = () => {
  return (
    <footer>
        <a href="" className='footer__logo'>chloeseah.</a>

        <ul className='permalinks'>
            <li><a href="#">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#experience">Experience</a></li>
            <li><a href="#internships">Internships</a></li>
            {/*<li><a href="#portfolio">Portfolio</a></li>
            <li><a href="#testimonials">Testimonials</a></li> */}
            <li><a href="#contact">Contact</a></li>
        </ul>

        <div className="footer__socials">
            <a href="https://www.facebook.com/chloee.syy/" target="_blank" rel="noreferrer"><FaFacebookF/></a>
            <a href="https://www.instagram.com/chloe_syy_/" target="_blank" rel="noreferrer"><FiInstagram/></a>
            <a href="https://twitter.com/chloe_syy_" target="_blank" rel="noreferrer"><IoLogoTwitter/></a>
        </div>

        <div className="footer__copyright">
            <small>&copy; chloeseah. All rights reserved.</small>
        </div>
    </footer>
  )
}

export default Footer